import { render, staticRenderFns } from "./Selected.vue?vue&type=template&id=f15e2d66&scoped=true"
import script from "./Selected.vue?vue&type=script&lang=js"
export * from "./Selected.vue?vue&type=script&lang=js"
import style0 from "./Selected.vue?vue&type=style&index=0&id=f15e2d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15e2d66",
  null
  
)

export default component.exports